import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';

import config from '../../config';

import styles from './ResetPasswordPage.css';

class ResetPasswordPage extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        location: PropTypes.object.isRequired,
    };

    state = {
        email: '',
        done: false,
    };

    componentDidMount() {
        this.setState({ email: this.props.location.state.email || '' });
    }

    handleResetClick = () => {
        const { email } = this.state;
        const {
            intl: { formatMessage },
        } = this.props;

        if (!email) {
            this.setState({ error: formatMessage({ id: 'ResetPasswordPage.fill in email' }) });
            return;
        }

        if (!/.+@.+\..+/.test(email)) {
            this.setState({ error: formatMessage({ id: 'ResetPasswordPage.Wrong email' }) });
            return;
        }

        fetch(`${config.backend}/recover/request`, {
            method: 'POST',
            body: JSON.stringify({ email, papers: true }),
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
        })
            .then(res => {
                if (res.ok) {
                    this.setState({ done: true });
                } else {
                    this.setState({ error: formatMessage({ id: 'ResetPasswordPage.Cannot reset password' }) });
                }
            })
            .catch(() => this.setState({ error: formatMessage({ id: 'ResetPasswordPage.Cannot reset password' }) }));
    };

    handleEmailEnter = (e, value) => {
        if (this.state.error) {
            this.setState({ error: '' });
        }

        this.setState({ email: value });
    };

    handleKeyDown = e => {
        if (e.which === 13) {
            this.handleResetClick();
        }
    };

    renderDone() {
        return (
            <p className={styles.success}>
                <FormattedMessage id="ResetPasswordPage.Email sent" values={{ email: <b>{this.state.email}</b> }} />
            </p>
        );
    }

    render() {
        const {
            intl: { formatMessage },
        } = this.props;

        if (this.state.done) {
            return this.renderDone();
        }

        return (
            <Fragment>
                <FormattedMessage id="ResetPasswordPage.reset password" />
                <br />
                <span className={styles.subtitle}>
                    <FormattedMessage id="ResetPasswordPage.Instructions will be sent" />
                </span>
                <TextField
                    value={this.state.email}
                    floatingLabelText={formatMessage({ id: 'ResetPasswordPage.email' })}
                    onChange={this.handleEmailEnter}
                    fullWidth
                    errorText={this.state.error}
                    errorStyle={{ float: 'left' }}
                    onKeyDown={this.handleKeyDown}
                />
                <RaisedButton
                    label={formatMessage({ id: 'ResetPasswordPage.send' })}
                    onClick={this.handleResetClick}
                    primary
                    className={styles.button}
                />
            </Fragment>
        );
    }
}

export default injectIntl(ResetPasswordPage);



// WEBPACK FOOTER //
// ./src/Pages/ResetPasswordPage/ResetPasswordPage.js